import { createApp } from "vue";

// Create a global Vue app instance for component registration
let globalVueApp: any = null;

export function setupVue() {
  if (!globalVueApp) {
    globalVueApp = createApp({});
    // Make Vue available globally for backward compatibility
    if (typeof window !== "undefined") {
      (window as any).Vue = {
        component: (name: string, component: any) => {
          (globalVueApp as any).component(name, component);
        },
        createApp: (options: any) => createApp(options),
        defineComponent: (options: any) =>
          (globalVueApp as any).defineComponent(options),
      };
    }
  }
  return globalVueApp;
}

export function getVueApp() {
  return globalVueApp || setupVue();
}
